
// // client/src/components/event/EventAdd.jsx
// // UPDATED with TimeSelect dropdown for guaranteed 5-minute restriction

// import React, { useRef, useState, useEffect } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';
// import MediaPicker from "../media/MediaPicker";
// import CameraComponent from '../media/CameraComponent';
// import ImageUploadModal from '../media/ImageUploadModal';
// import AppFooter from '../AppFooter';
// import TimeSelect from '../TimeSelect';
// // import { localToUTC, getNextSlotInTenantTZ } from '../../utils/timezoneUtils';
// import { localToUTC, getNextSlotInTenantTZ } from '../../utils/timezoneUtils';
// import { FaArrowLeft, FaCamera, FaUpload, FaTimes, FaPlus } from 'react-icons/fa';

// function EventAdd() {
//   const [name, setName] = useState('');
//   const [description, setDescription] = useState('');
//   const [type, setType] = useState('');

//   const [tenantTimezone, setTenantTimezone] = useState('America/Chicago');
  
//   // Separate date and time for better control
//   const [startDate, setStartDate] = useState(() => {
//     const now = new Date();
//     return now.toISOString().split('T')[0];
//   });
//   const [startTime, setStartTime] = useState('09:00');
  
//   const [endDate, setEndDate] = useState(() => {
//     const now = new Date();
//     return now.toISOString().split('T')[0];
//   });
//   const [endTime, setEndTime] = useState('17:00');
  
//   const [registerStatus, setRegisterStatus] = useState('');
//   const [imagePath, setImagePath] = useState(null);
//   const [showCamera, setShowCamera] = useState(false);
//   const [isImageModalOpen, setIsImageModalOpen] = useState(false);

//   const [mediaFiles, setMediaFiles] = useState([]);
//   const mediaPickerRef = useRef(null);

//   const navigate = useNavigate();
//   const { tenant } = useParams();
//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   const handleImageCaptured = (capturedImage) => {
//     fetch(capturedImage).then(res => res.blob()).then(b => 
//       setMediaFiles(f => [...f, new File([b], `capture-${Date.now()}.png`, { type: b.type || 'image/png' })])
//     );
//     setShowCamera(false);
//   };

//   const handleUploadComplete = () => {
//     setIsImageModalOpen(false);
//   };

//   // Combine date and time into datetime string for backend
//   const formatDateTime = (dateStr, timeStr) => {
//     if (!dateStr || !timeStr) return "";
//     return `${dateStr} ${timeStr}:00`;
//   };

//   const handleCancel = () => navigate(`/${tenant}/events`);

//   const checkDuplicateEvent = async () => {
//     const response = await axios.get(`${baseUrl}/api/events/${tenant}/checkname?name=${encodeURIComponent(name)}`);
//     return response.data.exists;
//   };

//   const onCameraUploadDefer = async (formData) => {
//     const blob = formData.get('file');
//     const file = new File([blob], `camera_${Date.now()}.jpg`, { type: blob.type || 'image/jpeg' });
//     setMediaFiles((prev) => [...prev, file]);
//     return { ok: true, path: 'local' };
//   };

//   // Fetch tenant timezone on mount
//   useEffect(() => {
//     const fetchTenantTimezone = async () => {
//       try {
//         const response = await axios.get(
//           `${baseUrl}/api/tenants/${tenant}/timezone`,
//           { withCredentials: true }
//         );
//         if (response.data.timezone) {
//           setTenantTimezone(response.data.timezone);
          
//           // Set default times in tenant timezone
//           const nextSlot = getNextSlotInTenantTZ(response.data.timezone, 60);
//           setStartDate(nextSlot.date);
//           setStartTime(nextSlot.time);
//           setEndDate(nextSlot.date);
//           setEndTime('17:00');
//         }
//       } catch (err) {
//         console.error('Failed to fetch tenant timezone:', err);
//         // Fall back to detecting browser timezone
//         const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
//         setTenantTimezone(browserTZ);
//       }
//     };
    
//     fetchTenantTimezone();
//   }, [tenant, baseUrl]);

//   const registerEvent = async (e) => {
//     e.preventDefault();

//     if (!tenant || isNaN(tenant)) {
//       console.error("Invalid tenant ID:", tenant);
//       setRegisterStatus("Invalid tenant ID. Please try again.");
//       return;
//     }

//     try {
//       const exists = await checkDuplicateEvent();
//       if (exists) {
//         setRegisterStatus('An event with this name already exists.');
//         return;
//       }

//       // Convert tenant timezone to UTC for database storage
//       const startDateTimeUTC = localToUTC(startDate, startTime, tenantTimezone);
//       const endDateTimeUTC = localToUTC(endDate, endTime, tenantTimezone);

//       console.log('Sending to backend:', {
//         startdate: startDateTimeUTC,
//         enddate: endDateTimeUTC,
//         timezone: tenantTimezone, // Send timezone for backend reference
//       });

//       const response = await axios.post(`${baseUrl}/api/events/${tenant}/registerevent`, {
//         name,
//         description,
//         type,
//         // startdate: formatDateTime(startDate, startTime),
//         // enddate: formatDateTime(endDate, endTime),
//         startdate: startDateTimeUTC,
//         enddate: endDateTimeUTC,
//         timezone: tenantTimezone,
//       }, { withCredentials: true });

//       if (!response.data?.success) {
//         setRegisterStatus('Failed to create event.');
//         return;
//       }

//       const eventId = response.data.eventId;
//       setRegisterStatus('Event created successfully!');

//       if (mediaFiles.length > 0) {
//         await uploadEventMedia(eventId);
//       }

//       navigate(`/${tenant}/${eventId}/eventDetail`);
//     } catch (error) {
//       console.error('Error registering event:', error);
//       setRegisterStatus('Error registering event. Please try again.');
//     }
//   };

//   const uploadEventMedia = async (eventId) => {
//     if (!eventId || mediaFiles.length === 0) return;

//     const formData = new FormData();
//     formData.append("reftable", "t_event");
//     formData.append("tableid", eventId);
//     mediaFiles.forEach(file => formData.append('files', file));

//     try {
//       const uploadResponse = await axios.post(
//         `${baseUrl}/api/${tenant}/${eventId}/uploadimage`,
//         formData,
//         { headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: true }
//       );

//       if (!uploadResponse.data?.success) {
//         console.error('Upload failed:', uploadResponse.data);
//       }
//     } catch (error) {
//       console.error('Error uploading media:', error);
//     }
//   };

//   const urlFor = (file) => URL.createObjectURL(file);

//   return (
//     <div className="container">
//       <h2 className="hdr hdr--primary hdr--lg">Create Event</h2>

//       <form onSubmit={registerEvent}>
//         <div className="form-group">
//           <label htmlFor="name">Event Name</label>
//           <input
//             type="text" className="form-control" id="name" name="name"
//             value={name} onChange={(e) => setName(e.target.value)}
//             placeholder="Enter event name" required
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="description">Event Description</label>
//           <textarea
//             className="form-control" id="description" name="description"
//             value={description} onChange={(e) => setDescription(e.target.value)}
//             placeholder="Enter event description"
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="type">Event Type</label>
//           <input
//             type="text" className="form-control" id="type" name="type"
//             value={type} onChange={(e) => setType(e.target.value)}
//             placeholder="Enter event type" required
//           />
//         </div>

//         <div className="form-group">
//           <label>Start Date & Time</label>
//           <div className="row">
//             <div className="col-md-6">
//               <input
//                 type="date" 
//                 className="form-control"
//                 value={startDate}
//                 onChange={(e) => setStartDate(e.target.value)}
//               />
//             </div>
//             <div className="col-md-6">
//               <TimeSelect
//                 value={startTime}
//                 onChange={setStartTime}
//                 tenantTimezone={tenantTimezone}
//                 showTimezone={true}
//               />
//             </div>
//           </div>
//           <small className="form-hint text-muted">
//             ⏰ Times are in 5-minute increments only
//           </small>
//         </div>

//         <div className="form-group">
//           <label>End Date & Time</label>
//           <div className="row">
//             <div className="col-md-6">
//               <input
//                 type="date" 
//                 className="form-control"
//                 value={endDate}
//                 onChange={(e) => setEndDate(e.target.value)}
//               />
//             </div>
//             <div className="col-md-6">
//               <TimeSelect
//                 value={endTime}
//                 onChange={setEndTime}
//                 tenantTimezone={tenantTimezone}
//                 showTimezone={true}
//               />
//             </div>
//           </div>
//           <small className="form-hint text-muted">
//             ⏰ Times are in 5-minute increments only
//           </small>
//         </div>

//         <MediaPicker ref={mediaPickerRef} onFilesChange={setMediaFiles} />
//         {mediaFiles.length > 0 && (
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(180px,1fr))', gap: 8, marginTop: 12 }}>
//             {mediaFiles.map((file, idx) => {
//               const src = urlFor(file);
//               const isVideo = file.type?.startsWith('video/');
//               return (
//                 <div key={`${file.name}-${idx}`} style={{ position: 'relative' }}>
//                   {isVideo ? (
//                     <video src={src} style={{ width: '100%', borderRadius: 8 }} controls />
//                   ) : (
//                     <img src={src} alt="" style={{ width: '100%', borderRadius: 8 }} />
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </form>

//       {registerStatus && <p className="status-message">{registerStatus}</p>}

//       {showCamera && (
//         <CameraComponent
//           tenantId={Number(tenant)}
//           onUpload={onCameraUploadDefer}
//           onSaved={() => {}}
//           onClose={() => setShowCamera(false)}
//         />
//       )}

//       {isImageModalOpen && (
//         <ImageUploadModal
//           tenantId={tenant}
//           imageName={`${Date.now()}_${tenant}_${name}`}
//           onUploadComplete={handleUploadComplete}
//           onClose={() => setIsImageModalOpen(false)}
//         />
//       )}

//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: "Back",
//             onClick: () => navigate(-1),
//           },
//           { icon: <FaCamera />, label: 'Take Photo', onClick: () => setShowCamera(true), disabled: false },
//           { icon: <FaUpload />, label: 'Upload Media', onClick: () => mediaPickerRef.current?.open(), disabled: false },
//           { icon: <FaPlus />, label: 'Create', onClick: registerEvent, type: 'submit' },
//         ]}
//       />
//     </div>
//   );
// }

// export default EventAdd;



// client/src/components/event/EventAdd.jsx
// UPDATED with Compact Time Selector + Timezone Support

import React, { useRef, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import MediaPicker from "../media/MediaPicker";
import CameraComponent from '../media/CameraComponent';
import ImageUploadModal from '../media/ImageUploadModal';
import AppFooter from '../AppFooter';
import TimeSelect from '../TimeSelect';
import { localToUTC, getNextSlotInTenantTZ } from '../../utils/timezoneUtils';
import { FaArrowLeft, FaCamera, FaUpload, FaTimes, FaPlus } from 'react-icons/fa';

function EventAdd() {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('');

  const [tenantTimezone, setTenantTimezone] = useState('America/Chicago');
  
  // Separate date and time for better control
  const [startDate, setStartDate] = useState(() => {
    const now = new Date();
    return now.toISOString().split('T')[0];
  });
  const [startTime, setStartTime] = useState('09:00');
  
  const [endDate, setEndDate] = useState(() => {
    const now = new Date();
    return now.toISOString().split('T')[0];
  });
  const [endTime, setEndTime] = useState('17:00');
  
  const [registerStatus, setRegisterStatus] = useState('');
  const [imagePath, setImagePath] = useState(null);
  const [showCamera, setShowCamera] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const [mediaFiles, setMediaFiles] = useState([]);
  const mediaPickerRef = useRef(null);

  const navigate = useNavigate();
  const { tenant } = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  const handleImageCaptured = (capturedImage) => {
    fetch(capturedImage).then(res => res.blob()).then(b => 
      setMediaFiles(f => [...f, new File([b], `capture-${Date.now()}.png`, { type: b.type || 'image/png' })])
    );
    setShowCamera(false);
  };

  const handleUploadComplete = () => {
    setIsImageModalOpen(false);
  };

  // Combine date and time into datetime string for backend
  const formatDateTime = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return "";
    return `${dateStr} ${timeStr}:00`;
  };

  const handleCancel = () => navigate(`/${tenant}/events`);

  const checkDuplicateEvent = async () => {
    const response = await axios.get(`${baseUrl}/api/events/${tenant}/checkname?name=${encodeURIComponent(name)}`);
    return response.data.exists;
  };

  const onCameraUploadDefer = async (formData) => {
    const blob = formData.get('file');
    const file = new File([blob], `camera_${Date.now()}.jpg`, { type: blob.type || 'image/jpeg' });
    setMediaFiles((prev) => [...prev, file]);
    return { ok: true, path: 'local' };
  };

  // Fetch tenant timezone on mount
  useEffect(() => {
    const fetchTenantTimezone = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/api/tenants/${tenant}/timezone`,
          { withCredentials: true }
        );
        if (response.data.timezone) {
          setTenantTimezone(response.data.timezone);
          
          // Set default times in tenant timezone
          const nextSlot = getNextSlotInTenantTZ(response.data.timezone, 60);
          setStartDate(nextSlot.date);
          setStartTime(nextSlot.time);
          setEndDate(nextSlot.date);
          setEndTime('17:00');
        }
      } catch (err) {
        console.error('Failed to fetch tenant timezone:', err);
        // Fall back to detecting browser timezone
        const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setTenantTimezone(browserTZ);
      }
    };
    
    fetchTenantTimezone();
  }, [tenant, baseUrl]);

  const registerEvent = async (e) => {
    e.preventDefault();

    if (!tenant || isNaN(tenant)) {
      console.error("Invalid tenant ID:", tenant);
      setRegisterStatus("Invalid tenant ID. Please try again.");
      return;
    }

    try {
      const exists = await checkDuplicateEvent();
      if (exists) {
        setRegisterStatus('An event with this name already exists.');
        return;
      }

      // Convert to UTC before sending to backend
      const startDateTimeUTC = localToUTC(startDate, startTime, tenantTimezone);
      const endDateTimeUTC = localToUTC(endDate, endTime, tenantTimezone);

      const response = await axios.post(`${baseUrl}/api/events/${tenant}/registerevent`, {
        name,
        description,
        type,
        startdate: startDateTimeUTC,
        enddate: endDateTimeUTC,
        timezone: tenantTimezone,
      }, { withCredentials: true });

      if (!response.data?.success) {
        setRegisterStatus('Failed to create event.');
        return;
      }

      const eventId = response.data.eventId;
      setRegisterStatus('Event created successfully!');

      if (mediaFiles.length > 0) {
        await uploadEventMedia(eventId);
      }

      navigate(`/${tenant}/${eventId}/eventDetail`);
    } catch (error) {
      console.error('Error registering event:', error);
      setRegisterStatus('Error registering event. Please try again.');
    }
  };

  const uploadEventMedia = async (eventId) => {
    if (!eventId || mediaFiles.length === 0) return;

    const formData = new FormData();
    formData.append("reftable", "t_event");
    formData.append("tableid", eventId);
    mediaFiles.forEach(file => formData.append('files', file));

    try {
      const uploadResponse = await axios.post(
        `${baseUrl}/api/${tenant}/${eventId}/uploadimage`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: true }
      );

      if (!uploadResponse.data?.success) {
        console.error('Upload failed:', uploadResponse.data);
      }
    } catch (error) {
      console.error('Error uploading media:', error);
    }
  };

  const urlFor = (file) => URL.createObjectURL(file);

  return (
    <div className="container">
      <h2 className="hdr hdr--primary hdr--lg">Create Event</h2>

      <form onSubmit={registerEvent}>
        <div className="form-group">
          <label htmlFor="name">Event Name</label>
          <input
            type="text" className="form-control" id="name" name="name"
            value={name} onChange={(e) => setName(e.target.value)}
            placeholder="Enter event name" required
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Event Description</label>
          <textarea
            className="form-control" id="description" name="description"
            value={description} onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter event description"
          />
        </div>

        <div className="form-group">
          <label htmlFor="type">Event Type</label>
          <input
            type="text" className="form-control" id="type" name="type"
            value={type} onChange={(e) => setType(e.target.value)}
            placeholder="Enter event type" required
          />
        </div>

        {/* START DATE & TIME */}
        <div className="form-group">
          <label>Start Date & Time</label>
          <div className="row">
            <div className="col-md-6 mb-2">
              <input
                type="date" 
                className="form-control"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </div>
            <div className="col-md-6">
              <TimeSelect
                value={startTime}
                onChange={setStartTime}
                tenantTimezone={tenantTimezone}
                showTimezone={true}
                id="start-time"
              />
            </div>
          </div>
        </div>

        {/* END DATE & TIME */}
        <div className="form-group">
          <label>End Date & Time</label>
          <div className="row">
            <div className="col-md-6 mb-2">
              <input
                type="date" 
                className="form-control"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
              />
            </div>
            <div className="col-md-6">
              <TimeSelect
                value={endTime}
                onChange={setEndTime}
                tenantTimezone={tenantTimezone}
                showTimezone={true}
                id="end-time"
              />
            </div>
          </div>
        </div>

        <MediaPicker ref={mediaPickerRef} onFilesChange={setMediaFiles} />
        {mediaFiles.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(180px,1fr))', gap: 8, marginTop: 12 }}>
            {mediaFiles.map((file, idx) => {
              const src = urlFor(file);
              const isVideo = file.type?.startsWith('video/');
              return (
                <div key={`${file.name}-${idx}`} style={{ position: 'relative' }}>
                  {isVideo ? (
                    <video src={src} style={{ width: '100%', borderRadius: 8 }} controls />
                  ) : (
                    <img src={src} alt="" style={{ width: '100%', borderRadius: 8 }} />
                  )}
                </div>
              );
            })}
          </div>
        )}
      </form>

      {registerStatus && <p className="status-message">{registerStatus}</p>}

      {showCamera && (
        <CameraComponent
          tenantId={Number(tenant)}
          onUpload={onCameraUploadDefer}
          onSaved={() => {}}
          onClose={() => setShowCamera(false)}
        />
      )}

      {isImageModalOpen && (
        <ImageUploadModal
          tenantId={tenant}
          imageName={`${Date.now()}_${tenant}_${name}`}
          onUploadComplete={handleUploadComplete}
          onClose={() => setIsImageModalOpen(false)}
        />
      )}

      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: "Back",
            onClick: () => navigate(-1),
          },
          { icon: <FaCamera />, label: 'Take Photo', onClick: () => setShowCamera(true), disabled: false },
          { icon: <FaUpload />, label: 'Upload Media', onClick: () => mediaPickerRef.current?.open(), disabled: false },
          { icon: <FaPlus />, label: 'Create', onClick: registerEvent, type: 'submit' },
        ]}
      />
    </div>
  );
}

export default EventAdd;